import React, { useRef, createContext, useEffect } from 'react'
import PropTypes from 'prop-types'

//styles
import styles from './ScrollableContent.module.scss'
import { useCallback } from 'react'

export const ScrollContext = createContext()

const ScrollableContent = ({ scrollTopDeps, children }) => {
  const scrollRef = useRef()

  const scrollToTop = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }, [])

  useEffect(() => {
    scrollToTop()
  }, [...scrollTopDeps])

  const contextValue = {
    scrollToTop,
  }

  return (
    <div ref={scrollRef} className={styles.scrollable}>
      <ScrollContext.Provider value={contextValue}>
        {children}
      </ScrollContext.Provider>
    </div>
  )
}

ScrollableContent.propTypes = {
  children: PropTypes.any,
  scrollTopDeps: PropTypes.array,
}

export default ScrollableContent
